import Colors from "../../../../theme/colors";

export default {
  tableColHeading: {
    padding: 2,
    color: "#5E5E5E",
    fontSize: "12px",
    textTransform: "uppercase",
  },
  headindStyle: {
    padding: "16px 0 16px 14px",
  },
  headerText: {
    fontSize: 12,
    borderLeft: "1px solid #877f7f",
    lineHeight: 1.2,
    paddingLeft: "6px",
    minWidth: "max-content",
  },
  column: {
    width: "9.5%",
    textTransform: "uppercase",
    // padding: "8px",
  },
  column2: {
    width: "12.5%",
    textTransform: "uppercase",
    // padding: "8px 10px",
    whiteSpace: "nowrap",
  },
  column3: {
    width: "15%",
    textTransform: "uppercase",
    // padding: "8px 10px",
    whiteSpace: "nowrap",
  },
  greyTableCell: {
    color: "#183053",
    fontSize: "12px",
    fontWeight: "500",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "left",
    paddingLeft: "30px",
  },
  blueTableCell: {
    color: "#183053",
    fontSize: "12px",
    fontWeight: "500",
    paddingLeft: "30px",
  },
  headingContainer: {
    display: "flex",
    flexDirection: "row",
    // justifyContent: "space-around",
    // width: "100%",
    borderBottom: "1px solid #ddd",
    padding: "10px 15px",
    paddingLeft: "1rem",
  },
  forward: {
    borderRadius: "4px",
    fontSize: 10,
    backgroundColor: Colors.midnightBlue,
    color: Colors.white,
    "&:hover": {
      backgroundColor: Colors.hoverBlue,
      color: Colors.white,
    },
    textAlign: "center",
    padding: "2px 8px",
    cursor: "pointer",
  },
  rejectbtn: {
    borderRadius: "4px",
    fontSize: 10,
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.midnightBlue}`,
    color: Colors.midnightBlue,
    "&:hover": {
      backgroundColor: Colors.white,
      color: Colors.hoverBlue,
      border: `1px solid ${Colors.hoverBlue}`,
    },
    textAlign: "center",
    padding: "2px 8px",
    marginTop: 4,
    cursor: "pointer",
  },
  accept: {
    borderRadius: "4px",
    fontSize: 10,
    backgroundColor: Colors.midnightBlue,
    color: Colors.white,
    "&:hover": {
      backgroundColor: Colors.hoverBlue,
      color: Colors.white,
    },
    textAlign: "center",
    padding: "2px 8px",
    cursor: "pointer",
  },
  cancel: {
    borderRadius: "4px",
    fontSize: 10,
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.midnightBlue}`,
    color: Colors.midnightBlue,
    "&:hover": {
      backgroundColor: Colors.white,
      color: Colors.hoverBlue,
      border: `1px solid ${Colors.hoverBlue}`,
    },
    textAlign: "center",
    padding: "2px 8px",
    marginTop: 4,
    cursor: "pointer",
  },
  cancelBtn: {
    marginLeft: "40px",
    marginTop: "-40px",
    width: "176px",
    height: "40px",
    color: "#043D90",
    border: "1px solid #043D90",
    borderRadius: "8px",
  },
  eyeIcon: {
    cursor: "pointer",
    textAlign: "center",
    marginTop: "-10px",
  },
  noColumn: {
    width: "1px",
    padding: "2px",
  },
  subHeadingStyle: {
    width: "100%",
    paddingRight: "1rem",
    paddingLeft: "0.6rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  actionBtn: {
    fontSize: "10px",
    width: "110px",
    height: "25px",
    borderRadius: "6px",
  },
  largeText: {
    display: "-webkit-box",
    WebkitLineClamp: "4",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#183053",
    fontSize: "12px",
    fontWeight: "500",
  },
  text: {
    color: "#183053",
    fontSize: "12px",
    fontWeight: "500",
  },

  nameHover: {
    position: "absolute",
    right: "78px",
    top: "40%",
    transform: "translateX(-50%)",
    color: "white",
    borderRadius: "4px",
    backgroundColor: "#9E9FA5",
    zIndex: 2,
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
    paddingLeft: "4px",
    paddingRight: "4px",
  },

  targetSiName: {
    minWidth: "88px",
    width: "120px",
    padding: "4px 8px 4px 8px",
    transition: "background-color 0.3s",
    cursor: "pointer",
  },
};

export const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  mini: {
    maxWidth: "5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
  large: {
    maxWidth: "16rem",
  },
};

export const ellipsisText = {
  text: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "WebkitBox",
    WebkitLineClamp: 4,
    WebkitBoxOrient: "vertical",
  },
};
